export default "__VITE_ASSET__b701f7a6__"